import React from 'react';
import PropTypes from 'prop-types';

export default class FormTextArea extends React.Component {
  static propTypes = {
    data: PropTypes.string,
    field: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
  };

  render() {
    const {data, field, handleChange, name} = this.props;
    const widget = field.widget;
    return (
      <div className={'FormTextArea'}>
        <textarea
          name={name}
          onChange={handleChange}
          value={data || ''}
          {...widget.attrs}
        />
      </div>
    );
  }
}
